<template>
  <div id="myChartPie" :style="{ width: '100vw', height: '260px' }"></div>
</template>

<script>
export default {
  props: ["pieData11"],
  data() {
    return {
      pieData: [],
    };
  },
  methods: {
    drawPie() {
      let data = this.pieData;
      data.forEach((item) => {
        item.value = (item.value / 10000).toFixed(2);
      });

      let myChartPie = this.$echarts.init(
        document.getElementById("myChartPie")
      );
      let option = {
        color: ["#2A8CF1", "#2DD18F", "#FFAC63"],
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          icon: "circle",
          bottom: "bottom",
          data: data,
          formatter: function (name) {
            let total = 0;
            let target;
            for (let i = 0, l = data.length; i < l; i++) {
              total += data[i].value;
              if (data[i].name == name) {
                target = data[i].value;
              }
            }
            if (name == "养殖业") {
              let arr = ["{a|" + target + "万" + "}", "{k|" + name + "}"];
              return arr.join("\n");
            } else if (name == "种植业") {
              let arr = ["{b|" + target + "万" + "}", "{k|" + name + "}"];
              return arr.join("\n");
            } else {
              let arr = ["{c|" + target + "万" + "}", "{k|" + name + "}"];
              return arr.join("\n");
            }
          },
          textStyle: {
            rich: {
              k: {
                fontSize: 13,
                padding: [0, 0, 0, 0],
                lineHeight: 25,
                color: "#181818",
              },
              a: {
                color: "#2A8CF1",
                verticalAlign: "top",
                align: "center",
                fontSize: 13,
                padding: [0, 0, 0, 0],
              },
              b: {
                verticalAlign: "top",
                align: "center",
                fontSize: 13,
                padding: [0, 0, 0, 0],
                color: "#2DD18F",
              },
              c: {
                verticalAlign: "top",
                align: "center",
                fontSize: 13,
                padding: [0, 0, 0, 0],
                color: "#FFAC63",
              },
            },
          },
        },
        series: [
          {
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{d}%",
                },
                labelLine: { show: true, length: 1 },
              },
            },

            type: "pie",
            radius: ["45%", "70%"],
            center: ["50%", "45%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "16",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: data,
          },
        ],
      };
      myChartPie.setOption(option);
    },
  },
  mounted() {
    this.pieData = this.pieData11;
  },
  watch: {
    pieData11(newvalue, oldvalue) {
      this.pieData = newvalue;
      this.drawPie();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/operationSummary/components/pieChart.vue